

import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { useLocation, useNavigate } from "react-router-dom";

import { base_url } from "./AdminUsers";
import toast from "react-hot-toast";
import api from "../../../utils/api";
const AdminAddRoles = () => {
  const location = useLocation();
  const navigate= useNavigate();

  const [Permissions, setPermissions] = useState([
    {
      name: "user",
      childs: [],
      isChecked:false
    },
    // {
    //   name: "settings",
    //   childs: [
    //     { name: "Create Manual Settings", isChecked: false },
    //     { name: "Create Telegram", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    // {
    //   name: "pending recharge",
    //   childs: [
    //     { name: "Accept Recharge", isChecked: false },
    //     { name: "Reject Recharge", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    // {
    //   name: "pending withdraw",
    //   childs: [
    //     { name: "Accept Withdraw", isChecked: false },
    //     { name: "Reject Withdraw", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    // {
    //   name: "deposit history",
    //   childs: [
    //     { name: "Accept dep", isChecked: false },
    //     { name: "Reject dep", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    // {
    //   name: "withdraw history",
    //   childs: [
    //     { name: "Accept with", isChecked: false },
    //     { name: "Reject with", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    // {
    //   name: "sports",
    //   childs: [
    //     { name: "Read Sports", isChecked: false },
    //     { name: "Edit Sports", isChecked: false },
    //     { name: "Add Sports", isChecked: false },
    //     { name: "Delete Sports", isChecked: false },
    //     { name: "Status Sports", isChecked: false },
    //     { name: "Setting Sports", isChecked: false },
    //     { name: "Priority Sports", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    {
      name: "add matches",
      childs: [
        { name: "Add Matches", isChecked: false },
        { name: "Active", isChecked: false },
        // { name: "Un Popular", isChecked: false },
        // { name: "Un Cup", isChecked: false },
        // { name: "Detailed Market", isChecked: false },
        // { name: "Fancy Active", isChecked: false },
      ],
      isChecked:false
    },
    // {
    //   name: "matches-history",
    //   childs: [
    //     { name: "Bet", isChecked: false },
    //     { name: "Position", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    {
      name: "manage sports results",
      childs: [
        { name: "Bet", isChecked: false },
        { name: "Position", isChecked: false }
      ],
      isChecked:false
    },
    // {
    //   name: "my market",
    //   childs: [
    //     { name: "Bet", isChecked: false },
    //     { name: "Position", isChecked: false }
    //   ],
    //   isChecked:false
    // },
    // {
    //   name: "manage fancy",
    //   childs: [
    //     { name: "Result", isChecked: false },
    //     { name: "Abandoned", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    // {
    //   name: "fancy history",
    //   childs: [
    //     { name: "RollBack", isChecked: false },
    //     { name: "Position", isChecked: false },
    //   ],
    //   isChecked:false
    // },
    {
      name: "casino-history",
      childs: [
        { name: "Read Casino", isChecked: false },
        { name: "Edit Casino", isChecked: false },
        { name: "Add Casino", isChecked: false },
        { name: "Delete Casino", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "settlement",
      childs: [
        { name: "Read settlement", isChecked: false },
        { name: "Create settlement", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "roles",
      childs: [
        { name: "Add Roles", isChecked: false },
        { name: "Read Role", isChecked: false },
        { name: "Edit Role", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "slider",
      childs: [
        { name: "Add Slider", isChecked: false },
        { name: "Read Slider", isChecked: false },
        { name: "Edit Slider", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "reports",
      childs: [
        { name: "My Bets", isChecked: false },
        { name: "Match History", isChecked: false },
        { name: "Profit Loss", isChecked: false },
        { name: "Sport History", isChecked: false },
        { name: "Super Admin Chip", isChecked: false },
        { name: "User Chip", isChecked: false },
        { name: "Commission History", isChecked: false },
        { name: "Week-report", isChecked: false },
        { name: "Settlement History", isChecked: false },
        { name: "Bet Delete", isChecked: false },
        { name: "Fancy History", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "admin bonus",
      childs: [
        { name: "Read Bonus", isChecked: false },
        { name: "Create Bonus", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "promo code",
      childs: [
        { name: "Read", isChecked: false },
        { name: "Create", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "market analysis",
      childs: [
        { name: "Read analysis", isChecked: false },
        { name: "Create analysis", isChecked: false },
      ],
      isChecked:false
    },
    
    {
      name: "event delay",
      childs: [
        { name: "Read evant", isChecked: false },
        { name: "Create event", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "live bets",
      childs: [
        { name: "Read analysis", isChecked: false },
        { name: "Create analysis", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "home",
      childs: [
        { name: "Read home", isChecked: false },
        { name: "Create home", isChecked: false },
      ],
      isChecked:false
    },
    {
      name: "delete bets",
      childs: [
        { name: "Read delete", isChecked: false },
        { name: "Create delete", isChecked: false },
      ],
      isChecked:false
    },
    

  ]);


  const [roleName, setRoleName] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [name, setName]= useState([]);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleChildPerm = (parentIndex, childIndex) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm, i) => {
        if (i === parentIndex) {
          const updatedChilds = perm.childs.map((child, j) => {
            if (j === childIndex) {
              return { ...child, isChecked: !child.isChecked };
            }
            return child;
          });
          const anyChecked = updatedChilds.some((child) => child.isChecked);
  
          return { 
            ...perm, 
            childs: updatedChilds, 
            isChecked: anyChecked
          };
        }
        return perm;
      })
    );
  };
  
  
  const handleParentPerm = (index) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm, i) => {
        if (i === index) {
          const updatedChilds = perm.childs.map((child) => ({
            ...child,
            isChecked: !perm.isChecked,
          }));
          return { ...perm, isChecked: !perm.isChecked, childs: updatedChilds };
        }
        return perm;
      })
    );
  };

  const handleSelectAll = () => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm) => ({
        ...perm,
        isChecked: true,
        childs: perm.childs.map((child) => ({
          ...child,
          isChecked: true,
        })),
      }))
    );
  };
  
  const handleDeselectAll = () => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((perm) => ({
        ...perm,
        isChecked: false,
        childs: perm.childs.map((child) => ({
          ...child,
          isChecked: false,
        })),
      }))
    );
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const checkedPermissions = Permissions
      .map((permission) => {
        const checkedChilds = permission.childs.filter((child) => child.isChecked);
        return {
          ...permission,
          childs: checkedChilds,
          isChecked: permission.isChecked ? permission.isChecked : false,
        };
      })
      .filter((permission) => permission.childs.length > 0 || permission.isChecked);
    
    try{
      const auth=localStorage.getItem('admin');
      const resp=await api.post(`/api/webapi/admin/createNewRole`,
        {payload:checkedPermissions,rolename:roleName},
        {
          headers:{
            Accept:'application/json',
            Authorization:`${auth}`
          }
        }
      );
      toast.success(resp.data.message);
      navigate('/admin/roles');
    }catch(err){
      toast.error('Error while creating the roles')
      console.log(err);
    }
  };

  const fetchRoles= async(req, res)=> {
    const auth = localStorage.getItem('admin');

    try{
      const response= await api.post('/api/webapi/admin/Rolelist',
        {},
        {
          headers:{
            Accept: 'application/json',
            Authorization: `${auth}`
          }
        }
      )

      const fullRoles= response.data.data;

      let arr=[];

      fullRoles?.map(full=> {
        const keyy= Object.keys(full);

        arr.push(keyy[0]);
        // console.log('kuyy',keyy[0]);
      });
// console.log('arr',arr);
      setName(arr);

      return arr;

    }catch(err){
      console.log('err',err);
    }
  }

  const updatePermissions = (roleNames) => {
    if (!roleNames.length) return;

    setPermissions(prevPermissions => {
        const updatedPermissions = prevPermissions.map(perm => {
            if (perm.name === 'user') {
              const staticChilds = [
                { name: "A/C chips In/Out", isChecked: false },
                { name: "View More/Edit", isChecked: false },
                { name: "Add Admin", isChecked: false }
            ];

            const dynamicChilds = roleNames.map(itemName => ({
              name: itemName,
              isChecked: false,
          }));

          return {
            ...perm,
            childs: [...dynamicChilds, ...staticChilds]
          };
            }
            return perm;
        });

        if (location.state?.roleObj) {
            const role = location.state.roleObj;
            setRoleName(Object.keys(role)[0]);

            const categoryPermissions = Object.values(role)
                .flatMap(roleArray => roleArray.map(el => Object.values(el)[0]))
                .flat();

            return updatedPermissions.map(perm => {
                const updatedChilds = perm.childs.map(child => ({
                    ...child,
                    isChecked: categoryPermissions?.includes(child.name) || child.isChecked
                }));

                return {
                    ...perm,
                    childs: updatedChilds,
                    isChecked: updatedChilds.some(child => child.isChecked)
                };
            });
        }

        return updatedPermissions;
    });
};

useEffect(() => {
    const initializeData = async () => {
        try {
            const roleNames = await fetchRoles();
            updatePermissions(roleNames);
        } catch (error) {
            console.error('Error initializing data:', error);
        }
    };

    initializeData();
}, []); // Empty dependency array for initial load

// Separate useEffect for handling location.state changes
useEffect(() => {
    if (location.state?.roleObj && name.length > 0) {
        updatePermissions(name);
    }
}, [location.state, name]);


  return (
    <div className="wrapper">
      {/* Main Sidebar */}
      {/* <AdminSidebar isSidebarOpen={isSidebarOpen} /> */}
      {/* {header} */}
      {/* <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
      /> */}
      <div
        className={`content-wrapper ${
          isSidebarOpen ? "" : "open-content-wrapper"
        }`}
      >
        <div className="side-body padding-top">
          <h1 className="page-title">
            <i className="sidebar-mini-lock" />
            {location.state? 'Edit Role': 'Add Role'}
          </h1>
          <div id="sidebar-mini-notifications" />
          <div className="page-content container-fluid">
            <div className="alerts"></div>
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-bordered">
                  {/* form start */}
                  <form className="form-edit-add" onSubmit={handleSubmit}>
                    <div className="panel-body">
                      <div className="form-group">
                        <label className="form-label fw-bold">Role Name</label>
                        <input
                          required
                          type="text"
                          className="form-control"
                          name="rolename"
                          id="rolename"
                          placeholder="Name"
                          value={roleName}
                          onChange={(e) => setRoleName(e.target.value)}
                        />
                      </div>
                      <label className="mt-4 fw-bold">Permissions</label>
                      <br />
                      <a href="##" className="permission-select-all permission" onClick={handleSelectAll}>
                        Select All
                      </a>{" "}
                      /
                      <a
                        href="##"
                        className="permission-deselect-all permission"
                        onClick={handleDeselectAll}
                      >
                        Deselect All
                      </a>
                      <ul className="permissions checkbox">
                        <li>
                          <input
                            type="checkbox"
                            id="users"
                            className="permission-group mr-1"
                            checked={Permissions[0].isChecked}
                          onChange={()=>handleParentPerm(0)}
                          />
                          <label htmlFor="users" 
                          >
                            <strong>User</strong>
                          </label>
                          <ul id="users-section">
                            {Permissions[0].childs.map((el, index) => {
                              return (
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`user-${index}`}
                                    name="permissions[17]"
                                    className="the-permission mr-1 sec1"
                                    defaultValue="Read Users"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(0,index)}
                                  />
                                  <label htmlFor={`user-${index}`}>
                                    {el.name}
                                  </label>
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                        {/* <li>
                          <input
                            type="checkbox"
                            id="settings"
                            className="permission-group mr-1"
                            checked={Permissions[1].isChecked}
                            onChange={()=>handleParentPerm(1)}
                          />
                          <label htmlFor="settings">
                            <strong>Settings</strong>
                          </label> */}
                          {/* <ul id="settings-section">
                            {Permissions[1].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`set-${index}`}
                                    name="permissions[22]"
                                    className="the-permission mr-1 sec2"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(1,index)}
                                  />
                                  <label htmlFor={`set-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul> */}
                        {/* </li> */}
                        {/* <li>
                          <input
                            type="checkbox"
                            id="browse_recharge"
                            className="permission-group mr-1"
                            checked={Permissions[2].isChecked}
                            onChange={()=>handleParentPerm(2)}
                          />
                          <label htmlFor="browse_recharge">
                            <strong>Pending Recharge</strong>
                          </label>
                          <ul id="recharge-section">
                            {Permissions[2].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`recharge-${index}`}
                                    name="permissions[22]"
                                    className="the-permission mr-1 sec3"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(2,index)}
                                  />
                                  <label htmlFor={`recharge-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul>
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="browse_withdraw"
                            className="permission-group mr-1"
                            checked={Permissions[3].isChecked}
                            onChange={()=>handleParentPerm(3)}
                          />
                          <label htmlFor="browse_withdraw">
                            <strong>Pending Withdraw</strong>
                          </label>
                          <ul id="withdraw-section">
                            {Permissions[3].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`withdraw-${index}`}
                                    name="permissions[22]"
                                    className="the-permission mr-1 sec4"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(3,index)}
                                  />
                                  <label htmlFor={`withdraw-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul>
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="deposit_history"
                            className="permission-group mr-1"
                            checked={Permissions[4].isChecked}
                            onChange={()=>handleParentPerm(4)}
                          />
                          <label htmlFor="deposit_history">
                            <strong>Deposit History</strong>
                          </label> */}
                          {/* <ul id="settings-section">
                            {Permissions[1].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`set-${index}`}
                                    name="permissions[22]"
                                    className="the-permission mr-1 sec5"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(1,index)}
                                  />
                                  <label htmlFor={`set-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul> */}
                        {/* </li>
                        <li>
                          <input
                            type="checkbox"
                            id="withdraw_history"
                            className="permission-group mr-1"
                            checked={Permissions[5].isChecked}
                            onChange={()=>handleParentPerm(5)}
                          />
                          <label htmlFor="withdraw_history">
                            <strong>Withdraw History</strong>
                          </label> */}
                          {/* <ul id="settings-section">
                            {Permissions[1].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`set-${index}`}
                                    name="permissions[22]"
                                    className="the-permission mr-1 sec6"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(1,index)}
                                  />
                                  <label htmlFor={`set-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul> */}
                        {/* </li> */}
                        {/* <li>
                          <input
                            type="checkbox"
                            id="sports"
                            className="permission-group mr-1"
                            checked={Permissions[6].isChecked}
                            onChange={()=>handleParentPerm(6)}
                          />
                          <label htmlFor="sports" >
                            <strong>Sports</strong>
                          </label>
                          <ul id="sports-section">
                            {Permissions[6].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`sports-${index}`}
                                    name="permissions[43]"
                                    className="the-permission mr-1 sec7"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(6,index)}
                                  />
                                  <label htmlFor={`sports-${index}`} >{el.name}</label>
                                </li>
                              )
                            })}
                          </ul>
                        </li> */}
                        <li>
                          <input
                            type="checkbox"
                            id="matches"
                            className="permission-group mr-1"
                            checked={Permissions[1].isChecked}
                            onChange={()=>handleParentPerm(1)}
                          />
                          <label htmlFor="matches" >
                            <strong>Add Matches</strong>
                          </label>
                          {/* <ul id="matches-section">
                            {
                              Permissions[7].childs.map((el, index) => {
                                return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`mat-${index}`}
                                    name="permissions[49]"
                                    className="the-permission mr-1 sec8"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(7,index)}
                                  />
                                  <label htmlFor={`mat-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                                )
                              })
                            }
                          </ul> */}
                        </li>
                        {/* <li>
                          <input
                            type="checkbox"
                            id="matches-history"
                            className="permission-group mr-1"
                            checked={Permissions[7].isChecked}
                            onChange={()=>handleParentPerm(7)}
                          />
                          <label htmlFor="matches-history" >
                            <strong>Matches-History</strong>
                          </label>
                          <ul id="matches-history-section">
                            {
                              Permissions[7].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`matH-${index}`}
                                      name="permissions[99]"
                                      className="the-permission mr-1 sec9"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(7,index)}
                                    />
                                    <label htmlFor={`matH-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        </li> */}
                        <li>
                          <input
                            type="checkbox"
                            id="manage Market"
                            className="permission-group mr-1"
                            checked={Permissions[2].isChecked}
                            onChange={()=>handleParentPerm(2)}
                          />
                          <label htmlFor="manage Market" >
                            <strong>Manage Sports Results</strong>
                          </label>
                          {/* <ul id="manage-section">
                            {
                              Permissions[9].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`manage-${index}`}
                                      name="permissions[82]"
                                      className="the-permission mr-1 sec10"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(9,index)}
                                    />
                                    <label htmlFor={`manage-${index}`} >{el.name}</label>
                                  </li>
                                )
                              })
                            }
                          </ul> */}
                         </li>
                        {/*<li>
                          <input
                            type="checkbox"
                            id="my market"
                            className="permission-group mr-1"
                            checked={Permissions[3].isChecked}
                            onChange={()=>handleParentPerm(3)}
                          />
                          <label htmlFor="my market">
                            <strong>My Market</strong>
                          </label> */}
                          {/* <ul id="my-section">
                            {Permissions[9].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`my-${index}`}
                                    name="permissions[22]"
                                    className="the-permission mr-1 sec11"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(9,index)}
                                  />
                                  <label htmlFor={`my-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul> */}
                        {/* </li> */}
                        {/* <li>
                          <input
                            type="checkbox"
                            id="manage fancy"
                            className="permission-group mr-1"
                            checked={Permissions[10].isChecked}
                            onChange={()=>handleParentPerm(11)}
                          />
                          <label htmlFor="manage fancy">
                            <strong>Manage Fancy</strong>
                          </label>
                          <ul id="settings-section">
                            {Permissions[1].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`set-${index}`}
                                    name="permissions[22]"
                                    className="the-permission mr-1 sec5"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(1,index)}
                                  />
                                  <label htmlFor={`set-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul>
                        </li> */}
                        {/* <li>
                          <input
                            type="checkbox"
                            id="fancy history"
                            className="permission-group mr-1"
                            checked={Permissions[12].isChecked}
                            onChange={()=>handleParentPerm(12)}
                          />
                          <label htmlFor="fancy history">
                            <strong>Fancy History</strong>
                          </label>
                          <ul id="settings-section">
                            {Permissions[1].childs.map((el, index) => {
                              return(
                                <li key={index}>
                                  <input
                                    type="checkbox"
                                    id={`set-${index}`}
                                    name="permissions[22]"
                                    className="the-permission mr-1 sec5"
                                    checked={el.isChecked}
                                    onChange={()=>handleChildPerm(1,index)}
                                  />
                                  <label htmlFor={`set-${index}`} >
                                    {el.name}
                                  </label>
                                </li>
                              )
                            })}
                          </ul>
                        </li> */}
                        <li>
                          <input
                            type="checkbox"
                            id="casino-games"
                            className="permission-group mr-1"
                            checked={Permissions[3].isChecked}
                            onChange={()=>handleParentPerm(3)}
                          />
                          <label htmlFor="casino-games" >
                            <strong>Casino History</strong>
                          </label>
                          {/* <ul id="casino-games-section">
                            {
                              Permissions[13].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`cas-${index}`}
                                      name="permissions[195]"
                                      className="the-permission mr-1 sec14"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(13,index)}
                                    />
                                    <label htmlFor={`cas-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                            
                          </ul> */}
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="settlement"
                            className="permission-group mr-1"
                            checked={Permissions[4].isChecked}
                            onChange={()=>handleParentPerm(4)}
                          />
                          <label htmlFor="settlement" >
                            <strong>Settlement</strong>
                          </label>
                          {/* <ul id="bonus-section">
                            {
                              Permissions[14].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`bon-${index}`}
                                      name="permissions[197]"
                                      className="the-permission mr-1 sec15"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(14,index)}
                                    />
                                    <label htmlFor={`bon-${index}`} >{el.name}</label>
                                  </li>
                                )
                              })
                            }
                          </ul> */}
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="roles"
                            className="permission-group mr-1"
                            checked={Permissions[5].isChecked}
                            onChange={()=>handleParentPerm(5)}
                          />
                          <label htmlFor="roles" >
                            <strong>Roles</strong>
                          </label>
                          <ul id="roles-section">
                            {
                              Permissions[5].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rol-${index}`}
                                      className="the-permission mr-1 sec16"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(5,index)}
                                    />
                                    <label htmlFor={`rol-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="slider"
                            className="permission-group mr-1"
                            checked={Permissions[6].isChecked}
                            onChange={()=>handleParentPerm(6)}
                          />
                          <label htmlFor="slider" >
                            <strong>Slider</strong>
                          </label>
                          {/* <ul id="roles-section">
                            {
                              Permissions[16].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rol-${index}`}
                                      className="the-permission mr-1 sec16"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(16,index)}
                                    />
                                    <label htmlFor={`rol-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                          </ul> */}
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="reports"
                            className="permission-group mr-1"
                            checked={Permissions[7].isChecked}
                            onChange={()=>handleParentPerm(7)}

                          />
                          <label htmlFor="reports" >
                            <strong>Reports</strong>
                          </label>
                          <ul id="reports-section">
                            {
                              Permissions[7].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rep-${index}`}
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(7,index)}
                                    />
                                    <label htmlFor={`rep-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                            
                          </ul>
                        </li>
                        {/* <li>
                          <input
                            type="checkbox"
                            id="admin_bonus"
                            className="permission-group mr-1"
                            checked={Permissions[8].isChecked}
                            onChange={()=>handleParentPerm(8)}

                          />
                          <label htmlFor="admin_bonus">
                            <strong>Admin Bonus</strong>
                          </label>
                          
                        </li> */}

                        <li>
                          <input
                            type="checkbox"
                            id="promo"
                            className="permission-group mr-1"
                            checked={Permissions[9].isChecked}
                            onChange={()=>handleParentPerm(9)}

                          />
                          <label htmlFor="promo" >
                            <strong>Promo Code</strong>
                          </label>
                          {/* <ul id="reports-section">
                            {
                              Permissions[19].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rep-${index}`}
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(18,index)}
                                    />
                                    <label htmlFor={`rep-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                            
                          </ul> */}
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="analysis"
                            className="permission-group mr-1"
                            checked={Permissions[10].isChecked}
                            onChange={()=>handleParentPerm(10)}

                          />
                          <label htmlFor="analysis" >
                            <strong>Market Analysis</strong>
                          </label>
                          {/* <ul id="reports-section">
                            {
                              Permissions[19].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rep-${index}`}
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(18,index)}
                                    />
                                    <label htmlFor={`rep-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                          </ul> */}
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="delay"
                            className="permission-group mr-1"
                            checked={Permissions[11].isChecked}
                            onChange={()=>handleParentPerm(11)}

                          />
                          <label htmlFor="delay" >
                            <strong>Event Delay</strong>
                          </label>
                          {/* <ul id="reports-section">
                            {
                              Permissions[19].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rep-${index}`}
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(18,index)}
                                    />
                                    <label htmlFor={`rep-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                              
                            
                          </ul> */}
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="livee"
                            className="permission-group mr-1"
                            checked={Permissions[12].isChecked}
                            onChange={()=>handleParentPerm(12)}

                          />
                          <label htmlFor="livee" >
                            <strong>live bets</strong>
                          </label>
                          {/* <ul id="reports-section">
                            {
                              Permissions[19].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rep-${index}`}
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(18,index)}
                                    />
                                    <label htmlFor={`rep-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                              
                            
                          </ul> */}
                        </li>
                        <li>
                          <input
                            type="checkbox"
                            id="homee"
                            className="permission-group mr-1"
                            checked={Permissions[13].isChecked}
                            onChange={()=>handleParentPerm(13)}

                          />
                          <label htmlFor="homee" >
                            <strong>Home</strong>
                          </label>
                          {/* <ul id="reports-section">
                            {
                              Permissions[19].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rep-${index}`}
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(18,index)}
                                    />
                                    <label htmlFor={`rep-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                              
                            
                          </ul> */}
                        </li>

                        <li>
                          <input
                            type="checkbox"
                            id="delete"
                            className="permission-group mr-1"
                            checked={Permissions[14].isChecked}
                            onChange={()=>handleParentPerm(14)}

                          />
                          <label htmlFor="delete" >
                            <strong>Delete Bets</strong>
                          </label>
                          {/* <ul id="reports-section">
                            {
                              Permissions[19].childs.map((el, index) => {
                                return(
                                  <li key={index}>
                                    <input
                                      type="checkbox"
                                      id={`rep-${index}`}
                                      className="the-permission mr-1 sec18"
                                      checked={el.isChecked}
                                      onChange={()=>handleChildPerm(18,index)}
                                    />
                                    <label htmlFor={`rep-${index}`} >
                                      {el.name}
                                    </label>
                                  </li>
                                )
                              })
                            }
                              
                            
                          </ul> */}
                        </li>
                      </ul>
                      <div className="panel-footer">
                        <button
                          type="submit"
                          id="submit"
                          className="btn btn-primary"
                          fdprocessedid="3x94fl"
                        >
                          {location.state? 'Update': 'Submit'}
                        </button>
                        {/* <button id="update" className="btn btn-primary" fdprocessedid="3x94fl">Update
                    </button> */}
                      </div>
                    </div>
                    {/* panel-body */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAddRoles;
